import axios from 'axios';

const login = async (authenticationServiceUrl, info) => {
  const axiosInstance = axios.create();
  axiosInstance.defaults.timeout = 10000;

  const response = await axiosInstance.post(
    authenticationServiceUrl + '/login',
    {
      company: info.company,
      username: info.userName,
      password: info.password
    }
  );

  return response;
};

const gp2Enabled = async (authenticationServiceUrl, email) => {
  const axiosInstance = axios.create();

  const response = await axiosInstance.get(
    authenticationServiceUrl + '/gp2-enabled/' + email
  );

  return response;
};

const gp2EnabledCompany = async (authenticationServiceUrl, company) => {
  const axiosInstance = axios.create();

  const response = await axiosInstance.get(
    authenticationServiceUrl + '/gp2-enabled-company/' + company
  );

  return response;
};

const tokenexchange = async authenticationServiceUrl => {
  const axiosInstance = axios.create();

  const response = await axiosInstance.get(
    authenticationServiceUrl + '/tokenexchange',
    { withCredentials: true }
  );
  return response;
};

const tokenexchangewithheader = async (
  authenticationServiceUrl,
  accessToken,
  idToken,
  idTokenHeader
) => {
  const axiosInstance = axios.create();

  const response = await axiosInstance.get(
    authenticationServiceUrl + '/tokenexchange',
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        [idTokenHeader]: idToken
      }
    }
  );
  return response;
};

const validateUser = async (
  authenticationServiceUrl,
  accessToken,
  idTokenHeader
) => {
  const axiosInstance = axios.create();

  const response = await axiosInstance.get(
    authenticationServiceUrl + '/validateUser',
    {
      headers: {
        [idTokenHeader]: accessToken
      }
    }
  );
  return response;
};

const password = async (
  authenticationServiceUrl,
  accessToken,
  idToken,
  idTokenHeader,
  info
) => {
  const axiosInstance = axios.create();

  const response = await axiosInstance.patch(
    authenticationServiceUrl + '/password',
    {
      companyHash: info.company,
      username: info.userName,
      oldPassword: info.oldPassword,
      newPassword: info.newPassword
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        [idTokenHeader]: idToken
      }
    }
  );

  return response;
};

const authenticate = async (
  authenticationServiceUrl,
  accessToken,
  idToken,
  idTokenHeader
) => {
  if (!authenticationServiceUrl || !accessToken || !idToken || !idTokenHeader) {
    return false;
  }

  const axiosInstance = axios.create();

  try {
    const response = await axiosInstance.get(authenticationServiceUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        [idTokenHeader]: idToken
      }
    });

    return response.status === 200;
  } catch (error) {
    return false;
  }
};

const createSession = async (
  authenticationServiceUrl,
  accessToken,
  idToken,
  idTokenHeader
) => {
  const axiosInstance = axios.create();

  try {
    await axiosInstance.post(authenticationServiceUrl + '/session', null, {
      headers: {
        'x-forwarded-host': 'api.smartdrivesystems.com',
        Authorization: `Bearer ${accessToken}`,
        [idTokenHeader]: idToken
      }
    });
  } catch (error) {
    console.warn('Error occured when creating session.', error);
  }
};

const logUserLogin = async (
  authenticationServiceUrl,
  accessToken,
  idToken,
  idTokenHeader
) => {
  const axiosInstance = axios.create();

  try {
    await axiosInstance.post(authenticationServiceUrl + '/lastlogin', null, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        [idTokenHeader]: idToken
      }
    });
  } catch (error) {
    console.warn('Error occured when logging user login.', error);
  }
};

export {
  login,
  password,
  authenticate,
  createSession,
  logUserLogin,
  gp2Enabled,
  gp2EnabledCompany,
  tokenexchange,
  tokenexchangewithheader,
  validateUser
};



// WEBPACK FOOTER //
// ./src/apis/AuthApi.js